import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import '../../styles/landing/GuestFlowSection.css';

const STEP_KEYS = ['1', '2', '3', '4', '5'] as const;

const GuestFlowSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section
            id="how-it-works"
            className="landing-section landing-section--blush"
            aria-labelledby="guest-flow-heading"
        >
            <div className="landing-container">
                <SectionHeader
                    title={t('guestFlow.title')}
                    subtitle={t('guestFlow.subtitle')}
                    id="guest-flow-heading"
                />
                <ol className="guest-flow__steps">
                    {STEP_KEYS.map((step, index) => (
                        <li key={step} className="guest-flow__step">
                            <span className="guest-flow__number" aria-hidden="true">
                                {index + 1}
                            </span>
                            <h3 className="guest-flow__text">{t(`guestFlow.steps.${step}`)}</h3>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
};

export default GuestFlowSection;
